import { useTranslation } from 'next-i18next';
import { GalleryComponentInterface } from '../../../../../interfaces/pagebuilder';
import VyUpload from '../../../../common/VyUpload';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

interface GallerySettingsTableInterface {
  component: GalleryComponentInterface;
  onChange: (c: GalleryComponentInterface) => void;
}

// deprecated and moved to image component
const GallerySettingsTable = ({ component, onChange }: GallerySettingsTableInterface) => {
  const { t } = useTranslation(['pagebuilder']);

  function handleAddFile(fileId?: string | null, fileIds?: string[]) {
    if (!fileId && !fileIds) return;

    const _images = [...(component.images || [])];
    const _empty = _images.indexOf(null);

    if (fileId) {
      if (_empty >= 0) _images.splice(_empty, 1, fileId);
      else _images.push(fileId);
    }
    if (fileIds) fileIds.map((id) => _images.push(id));

    const _component = {
      ...component,
      images: _images,
    };
    onChange(_component);
  }
  const settingSections: PageBuilderSettingsSection[] = [
    {
      settings: [
        {
          path: 'autoplay',
          type: 'boolean',
          label: t('pagebuilder:autoplay'),
        },
        {
          path: 'controls',
          type: 'boolean',
          label: t('pagebuilder:controls'),
        },
        {
          label: t('pagebuilder:add-image'),
          content: (
            <VyUpload
              id={'gallery-image'}
              showCropButton={false}
              showPreview={false}
              withRotation={false}
              acceptedFileTypes=".jpeg, .jpg, .gif, .png, .webp"
              withCrop
              noCropForMediaCenter
              cropAspectRatio={
                component.customStyling?.aspectRatio?.x && component.customStyling?.aspectRatio?.y
                  ? component.customStyling?.aspectRatio?.x / component.customStyling?.aspectRatio?.y
                  : component.customStyling?.height && component.customStyling?.width
                  ? component.customStyling?.width / component.customStyling?.height
                  : 4 / 1
              }
              onMultiFilesUpload={(fileIds) => handleAddFile(undefined, fileIds)}
              onChange={(fileId) => handleAddFile(fileId)}
            />
          ),
        },
        {
          type: 'dnd',
          path: 'images',
          dndItems: component.images,
        },
      ],
    },
  ];

  return <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} />;
};
export default GallerySettingsTable;
